<template>
  <div class="container-fluid">
    <div class="d-none d-md-block">
      <!-- page header -->
      <b-row class="mt-5 mb-3">
        <b-col sm="12" md="6">
          <h2>{{ pageType.title }}</h2>
          <b-btn
            @click="moveToNextRoute"
            variant="outline-info"
            pill
            class="mb-2"
            >{{ pageType.btnText }}</b-btn
          >
        </b-col>
        <b-col sm="12" md="6" class="text-right">
          <b-btn
            :to="{ name: 'teachers.create.deliberations' }"
            pill
            variant="info"
            class="text-white add-user"
          >
            <BIconPlus></BIconPlus>
            <span>Créer une nouvelle délibération</span>
          </b-btn>
        </b-col>
      </b-row>

      <!-- filters -->
      <div class="bg-light py-4 container-fluid">
        <b-form inline class="justify-content-between">
          <div class="mb-2">
            <label class="mr-3 d-inline" for="inline-form-input-name"
              >Statut</label
            >
            <b-form-select
              v-model="statusSelected"
              :options="statusOptions"
              class="mr-3"
              id="select-horizontal"
            >
              <template v-slot:first>
                <b-form-select-option :value="null">
                  Choisir un statut
                </b-form-select-option>
              </template>
            </b-form-select>
            <label class="mr-3 d-inline" for="inline-form-group">Groupe</label>
            <b-form-select
              v-model="groupSelected"
              :options="groups.data.data"
              class="mr-3"
              id="select-horizontal"
              text-field="name"
              value-field="id"
            >
              <template v-slot:first>
                <b-form-select-option :value="null">
                  Choisir un groupe
                </b-form-select-option>
              </template>
            </b-form-select>
          </div>
          <div>
            <label class="sr-only" for="inline-form-input-name">search</label>
            <b-input
              id="inline-form-input-name"
              class="mb-2 mr-sm-2 mb-sm-0"
              placeholder="Recherche"
              v-model="nameFilter"
              @change="onChange({ title: $event })"
            ></b-input>
            <b-btn :disabled="!nameFilter" pill variant="primary"
              >Rechercher</b-btn
            >
          </div>
        </b-form>
      </div>
      <b-table
        ref="selectableTable"
        show-empty
        stacked="md"
        :items="teacherDlibr.data.data"
        outlined
        bordered
        :busy="isBusy"
        hover
        :fields="currentFields"
        empty-text="Il n'y a pas de délibération correspondant à vos critères de recherche"
      >
        <template v-slot:table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle"></b-spinner>
            <p>Actualisation en cours...</p>
          </div>
        </template>
        <template v-slot:head(link)>
          <b-icon icon="link45deg" variant="seconday"></b-icon>
        </template>
        <template v-slot:head(total_participants)>
          <b-icon
            icon="people-fill"
            variant="secondary"
            v-b-tooltip.hover
            title="Nombre de participants"
          ></b-icon>
        </template>
        <template v-slot:head(total_comments)>
          <b-icon
            icon="chat-fill"
            variant="secondary"
            v-b-tooltip.hover
            title="Publication(s)"
          ></b-icon>
        </template>
        <template v-slot:head(total_messages)>
          <b-icon
            icon="envelope-fill"
            variant="info"
            v-b-tooltip.hover
            title="Message(s)"
          ></b-icon>
        </template>

        <template v-slot:head(total_comments_flagged)>
          <span
            class="text-warning"
            v-b-tooltip.hover
            title="Publication signalée(s)"
          >
            <BIconFlagFill></BIconFlagFill>
          </span>
        </template>

        <template v-slot:cell(actions)="row">
          <b-dropdown
            size="sm"
            class="ml-1"
            variant="none"
            toggle-class="text-decoration-none"
            no-caret
            dropleft
            pill
          >
            <template v-slot:button-content>
              <b-icon icon="three-dots" variant="seconday"></b-icon>
            </template>

            <b-dropdown-item
              :to="{
                name: 'teacher.edit.deliberation',
                params: { id: row.item.id }
              }"
              >Modifier</b-dropdown-item
            >
            <b-dropdown-item
              @click="confirmStatus(row.item)"
              v-if="Boolean(row.item.status)"
              >Supprimer</b-dropdown-item
            >
          </b-dropdown>
        </template>

        <template v-slot:cell(status)="row">
          <template v-if="row.item.status == 1">
            <b-icon class="h5" icon="circle-fill" variant="success"></b-icon>
          </template>
          <template v-else>
            <b-icon class="h5" icon="circle-fill" variant="primary"></b-icon>
          </template>
        </template>

        <template v-slot:cell(privacy)="row">
          <template v-if="row.item.privacy == 1">
            <!-- private -->
            <b-icon class="h5" icon="eye-slash" variant="primary"></b-icon>
          </template>
          <template v-else-if="row.item.privacy == 2">
            <!-- public -->
            <b-icon class="h5" icon="eye" variant="primary"></b-icon>
          </template>
          <template v-else-if="row.item.privacy == 3">
            <!-- invité -->
            <b-icon class="h5" icon="envelope-open" variant="primary"></b-icon>
          </template>
        </template>

        <template v-slot:cell(deliberation)="row">
          <b-link
            :to="{
              name: 'deliberation.byUrl',
              params: { teacher: row.item.teacher.id, url: row.item.url }
            }"
            >{{ row.item.title }} -
            <span>{{ row.item.description }}</span></b-link
          >

          <div>
            <b-link
              ref="mylink"
              :to="{
                name: 'deliberation.byUrl',
                params: { teacher: row.item.teacher.id, url: row.item.url }
              }"
            >
              <small>{{ urlPreview(row.item) }}</small>
            </b-link>
            <b-button
              :id="`tooltip-target-${row.item.id}`"
              variant="none"
              toggle-class="text-decoration-none"
              size="sm"
              pill
              class="ml-1"
              @click="copyURL(row.item)"
            >
              <font-awesome-icon
                style="font-size: 1.3rem"
                :icon="['far', 'copy']"
                class="text-primary"
                size="2x"
              />
            </b-button>
            <b-tooltip
              :target="`tooltip-target-${row.item.id}`"
              triggers="hover"
            >
              {{ tooltipCopy }}
            </b-tooltip>
          </div>
        </template>

        <template v-slot:cell(total_comments_flagged)="row">
          <b-button
            variant="link"
            @click="
              goToFlagged({
                id: row.item.id,
                teacher: row.item.teacher.id,
                url: row.item.url
              })
            "
          >
            {{ row.value + row.item.total_flagged_messages.length }}
          </b-button>
        </template>
        <template v-slot:cell(total_messages)="row">
          <b-button
            variant="link"
            @click="
              showLastConnection({
                id: row.item.id,
                data: row.item.total_messages,
                title: isStudent
                  ? 'Nouveau message de votre enseignant'
                  : 'Message(s)'
              })
            "
          >
            {{ row.value }}
          </b-button>
        </template>
        <!-- mobile -->
        <template v-slot:cell(deliberation_mobile)="row">
          <b-link class="text-white"
            >{{ row.item.title }} -
            <span>{{ row.item.description }}</span></b-link
          >

          <div>
            <b-link
              class="text-white"
              :to="{
                name: 'deliberation.byUrl',
                params: { teacher: row.item.teacher.id, url: row.item.url }
              }"
            >
              <small>{{ urlPreview(row.item) }}</small>
            </b-link>
          </div>
        </template>
      </b-table>

      <div class="d-flex justify-content-end">
        <div class="d-flex align-items-center ml-5">
          <b-icon class="h5 mr-2" icon="circle-fill" variant="success"></b-icon>
          <span>Actif</span>
        </div>
        <div class="d-flex align-items-center ml-5">
          <b-icon class="h5 mr-2" icon="circle-fill" variant="primary"></b-icon>
          <span>Inactif</span>
        </div>
        <div class="d-flex align-items-center ml-5">
          <b-icon class="mr-2 h5" icon="eye-slash" variant="primary"></b-icon>
          <span>Privée</span>
        </div>
        <div class="d-flex align-items-center ml-5">
          <b-icon class="mr-2 h5" icon="eye" variant="primary"></b-icon>
          <span>Publique</span>
        </div>
        <div class="d-flex align-items-center ml-5">
          <b-icon
            class="mr-2 h5"
            icon="envelope-open"
            variant="primary"
          ></b-icon>
          <span>Invité</span>
        </div>
      </div>
    </div>
    <!-- display mobile -->
    <div class="d-md-none">
      <DlibrsMobile @showLastConnection="showLastConnection" />
    </div>
    <!-- User Interface controls -->
    <b-row>
      <b-col cols="4" class="my-1">
        <b-pagination
          pills
          v-model="table.currentPage"
          :total-rows="table.totalRows"
          :per-page="table.perPage"
          class="my-0"
          @change="pageChange"
        ></b-pagination>
      </b-col>
    </b-row>
    <LastConnectionModal
      :data="dataLastConnection"
      :title="titleLastConnection"
    />
  </div>
</template>

<script>
/**
 * @file       Teachers deliberation component.
 * @author     Appwapp <info@appwapp.com>
 * @copyright  © Centre collégial de développement de matériel didactique, Collège de Maisonneuve, 2021
 * @license    https://www.ccdmd.qc.ca
 * @version    1.0
 */

import store from "@/store";
import { mapState } from "vuex";
import DlibrsMobile from "@/modules/deliberations/components/dlibrsMobile.vue";
import LastConnectionModal from "@/modules/deliberations/components/lastConnectionModal.vue";
import { dlibrsMixin } from "@/modules/deliberations/mixins";

/**
 * Export the component.
 * 
 * @type  {Object}
 */
export default {
  name: "teacherDlibrList",
  mixins: [dlibrsMixin],
  components: { DlibrsMobile, LastConnectionModal },

  /**
   * Data used in the component.
   *
   * @return  {Object}
   */
  data() {
    return {
      nameFilter: null,
      statusSelectedTemp: true,
      statusOptions: [
        {
          text: "Actif",
          value: 1
        },
        { text: "Inactif", value: 0 }
      ],
      fields: {
        ownGroups: [
          {
            key: "deliberation_mobile",
            label: "Délibération",
            sortable: true,
            sortDirection: "desc",
            class: "d-md-none bg-primary text-white"
          },
          {
            key: "group.name",
            label: "Groupes",
            sortable: true,
            sortDirection: "desc"
          },
          {
            key: "status",
            label: "Statut",
            sortable: true,
            sortDirection: "desc",
            class: "text-center"
          },
          {
            key: "privacy",
            label: "Visibilité",
            sortable: true,
            sortDirection: "desc",
            class: "text-center"
          },
          {
            key: "deliberation",
            label: "Délibérations",
            sortable: true,
            sortDirection: "desc",
            class: "d-none d-md-block"
          },
          {
            key: "total_participants",
            label: "Participant",
            class: "text-center border-right-0 border-left-0"
          },
          {
            key: "total_comments",
            label: "Commentaire",
            class: "text-center border-right-0 border-left-0"
          },
          {
            key: "total_comments_flagged",
            label: "Flag",
            class: "text-center border-right-0 border-left-0",
            formatter: value => value.length
          },
          {
            key: "total_messages",
            label: "Message",
            class: "text-center border-right-0 border-left-0",
            formatter: value => value.length
          },
          {
            key: "actions",
            label: "",
            class: "text-center border-right-0 border-left-0"
          }
        ],
        allGroups: [
          {
            key: "status",
            label: "Statut",
            sortable: true,
            sortDirection: "desc",
            class: "text-center"
          },
          {
            key: "deliberation",
            label: "Délibération",
            sortable: true,
            sortDirection: "desc"
          },
          {
            key: "total_participants",
            label: "Participant",
            class: "text-center border-right-0 border-left-0"
          },
          {
            key: "total_comments",
            label: "Commentaire",
            class: "text-center border-right-0 border-left-0"
          },
          {
            key: "teacher",
            label: "Nom de l'enseignant",
            sortable: true,
            sortDirection: "desc",
            formatter: (value, key, item) => {
              return `${item.teacher.name} ${item.teacher.last_name}`;
            }
          }
        ]
      },
      tooltipCopy: "Copier le lien dans le presse-papiers",
      configurationMsg: {
        title: "Veuillez confirmer",
        okTitle: "Accepter",
        cancelTitle: "Annuler",
        footerClass: "p-2",
        hideHeaderClose: false,
        centered: true
      }
    };
  },

  /**
   * Computed properties.
   * 
   * @type  {Object}
   */
  computed: {
    ...mapState({
      teacherDlibr: state => state.deliberations.teacherDlibr,
      groups: state => state.groups.teacherGroups,
      teachers: state => state.admin.users
    }),

    /**
     * Pager table.
     *
     * @return     {Object}
     */
    table() {
      return {
        totalRows: this.teacherDlibr.data.total,
        currentPage: this.teacherDlibr.data.current_page,
        perPage: this.teacherDlibr.data.per_page
      };
    },

    /**
     * Check if the status is busy.
     *
     * @return     {bool}  Busy or not.
     */
    isBusy() {
      return this.teacherDlibr.status === "fetching";
    },

    /**
     * Deliberation status filter.
     *
     * @type     {Object}
     */
    statusSelected: {
      get() {
        if (this.statusSelectedTemp) {
          return null;
        } else {
          return this.teacherDlibr.filters.status;
        }
      },
      set(value) {
        this.statusSelectedTemp = false;
        this.$store.commit("deliberations/setTeacherDlibrFilters", {
          fields: { status: value }
        });
        this.$store.dispatch("deliberations/getTeacherDlibr");
      }
    },

    /**
     * Deliberation group filter.
     *
     * @type     {Object}
     */
    groupSelected: {
      get() {
        return this.teacherDlibr.filters.group;
      },
      set(value) {
        this.$store.commit("deliberations/setTeacherDlibrFilters", {
          fields: { group: value }
        });
        this.$store.dispatch("deliberations/getTeacherDlibr");
      }
    },

    /**
     * Check if per teacher.
     *
     * @return     {bool}  Per teacher or not.
     */
    routeIsPerTeacher() {
      return Boolean(this.$route.params.id);
    },

    /**
     * Deliberation page type.
     *
     * @return     {Object}
     */
    pageType() {
      return {
        title: this.routeIsPerTeacher
          ? "Vos délibérations"
          : "Toutes les délibération",
        btnText: this.routeIsPerTeacher
          ? "Voir toutes les délibérations dans Dlibr"
          : "Retour à vos délibérations"
      };
    },

    /**
     * Groups according to teacher.
     *
     * @return     {Object}
     */
    currentFields() {
      return this.routeIsPerTeacher
        ? this.fields.ownGroups
        : this.fields.allGroups;
    }
  },

  /**
   * Before route change.
   * 
   * @param  {string}   to     Destination
   * @param  {string}   from   (Unused)
   * @param  {Object}   next   The action
   */
  beforeRouteEnter(to, from, next) {
    to.params.id
      ? store.commit("deliberations/setTeacherDlibrFilters", {
          fields: { teacher: to.params.id, status: 1 },
          reset: true
        })
      : store.commit("admin/setUserFilters", {
          fields: { role: "teacher", resourcesPerPage: 50 },
          reset: true
        });
    Promise.all([
      store.dispatch("deliberations/getTeacherDlibr"),
      store.dispatch("groups/getTeacherGroups"),
      store.dispatch("admin/getUsers")
    ])
      .then(() => {
        next();
        store.commit("groups/setTeacherGroupsFilters", {
          reset: true,
          fields: {
            teacher: parseInt(to.params.id),
            status: 1,
            resourcesPerPage: 100
          }
        });
        store.dispatch("groups/getTeacherGroups");
        store.dispatch("admin/getUsers");
      })
      .catch(() => next());
  },

  /**
   * Methods.
   * 
   * @type  {Object}
   */
  methods: {
    /**
    * Confirmation of the delete of the teachers deliberation.
    * 
    * @param  {Object}  item  Selected deliberation
    */
    confirmStatus(item) {
      this.$bvModal
        .msgBoxConfirm(
          "Confirmez que vous souhaitez vraiment supprimer la delibération",
          this.configurationMsg
        )
        .then(value => {
          if (value) this.updateStatus(item);
        })
        .catch();
    },

    /**
    * Delete the teachers deliberation.
    * 
    * @param  {Object}  item  Selected deliberation
    */
    updateStatus(item) {
      const payload = {
        deliberation: {
          id: item.id,
          status: 0
        }
      };
      this.$store
        .dispatch("deliberations/putDlibr", payload)
        .then(() => {
          this.$root.$bvToast.toast(
            "La délibération a été supprimé avec succès.",
            {
              title: "Delete success"
            }
          );
        })
        .catch(err => {
          this.$root.$bvToast.toast(
            err.response
              ? err.response.data.message
              : "La délibération n'a pas été supprimé avec succès.",
            {
              title: "Erreur",
              variant: "danger"
            }
          );
        });
    },

    /**
    * Teachers deliberation list.
    */
    moveToNextRoute() {
      if (this.routeIsPerTeacher) {
        this.$store.commit("deliberations/setTeacherDlibrFilters", {
          reset: true
        });
        this.$router.push({ name: "teachers.deliberations" });
      } else {
        this.$router.push({
          name: "teacher.own.deliberations",
          params: { id: this.profile.id }
        });
      }
    },

    /**
    * On change of page of the teachers deliberation.
    * 
    * @param  {Object}  page  Destination page
    */
    pageChange(page) {
      this.$store.commit("deliberations/setTeacherDlibrFilters", {
        fields: { page }
      });
      this.$store.dispatch("deliberations/getTeacherDlibr");
    },

    /**
    * On change of teachers deliberation filters.
    * 
    * @param  {Object}  select  Selected filters
    */
    onChange(select) {
      this.$store.commit("deliberations/setTeacherDlibrFilters", {
        fields: { ...select }
      });
      this.$store.dispatch("deliberations/getTeacherDlibr");
    },

    /**
    * Generates the teachers deliberation URL.
    * 
    * @param  {Object}  item  Selected deliberation
    *
    * @return  {string}
    */
    urlPreview(item) {
      return `${window.location.origin}/#/${item.teacher.id}/${item.url}`;
    },

    /**
    * Copies the teachers deliberation URL.
    * 
    * @param  {Object}  item  Selected deliberation
    */
    copyURL(item) {
      navigator.clipboard
        .writeText(`${window.location.origin}/#/${item.teacher.id}/${item.url}`)
        .then(() => {
          document.execCommand("copy");
          this.tooltipCopy = "Lien copié";
        })
        .catch(() => {});
    }
  },

  /**
  * Show tooltip of the copy deliberation URL.
  */
  mounted() {
    setTimeout(() => {
      store.dispatch('deliberations/getTeacherDlibr');
    }, 1000);

    this.$root.$on("bv::tooltip::show", () => {
      this.tooltipCopy = "Copier le lien dans le presse-papiers";
    });
  }
};
</script>

<style lang="scss" scoped></style>
